module.exports = __webpack_public_path__ + "static/videos/woodcut_ink003.628071f.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/woodcut/woodcut_ink003.mp4
// module id = 478
// module chunks = 1